<template>
  <div v-if="!loading" class="layout" style="background-color: #f5f5f5">
    <van-tabs
      class="vantabs"
      v-model="active"
      animated
      swipeable
      swipe-threshold="3"
      color="#2E94E5"
      line-height="3px"
      title-active-color="#2E94E5"
    >
      <van-tab v-for="item in navData" :key="item.text" :title="item.text">
        <component
          v-if="item.show"
          :is="item.url"
          :list.sync="item.data"
          @show-dialog="showDialog"
        ></component>
      </van-tab>
    </van-tabs>
    <van-popup v-model="showSigns" closeable :style="{ height: '80%' }">
      <div class="sign-middle">
        <img src="http://img.xiaoqijiankang.com/images/signs.jpg" />
      </div>
    </van-popup>
    <BottomNav v-if="showNav == 1" />
  </div>
</template>
<script>
import Organ from "@/components/Organ";
import Summary from "@/components/Summary";
import LntelligentEvaluation from "@/components/LntelligentEvaluation";
import Physiology from "@/components/Physiology";
import Brain from "@/components/Brain";
import Diabetes from "@/components/Diabetes";
import Disease from "@/components/Disease";
import translate from "./PeaceMindH5/components/translate";
import SeriousDis from "@/components/SeriousDis";
import Healthy from "@/components/Healthy";
import BottomNav from "@/components/BottomNav";
import Report from "../models/Report";
import { Notify } from "vant";
export default {
  components: {
    Summary,
    LntelligentEvaluation,
    Physiology,
    Brain,
    Diabetes,
    Disease,
    Healthy,
    Organ,
    BottomNav,
    SeriousDis,
    translate,
  },
  data() {
    return {
      showSigns: false,
      active: 0,
      loading: true,
      navData: [
        { text: "健康概况", url: "Organ", list: "organ", show: true },
        { text: "健康总评", url: "Summary", list: "summary", show: true },
        {
          text: "生理系统风险",
          url: "Physiology",
          list: "physiology",
          show: true,
        },
        { text: "脑血管风险", url: "Brain", list: "brain", show: true },
        { text: "糖尿病风险", url: "Diabetes", list: "Diabetes", show: true },
        { text: "疾病风险", url: "Disease", list: "Disease", show: true },
        { text: "健康管理建议", url: "Healthy", list: "healthy", show: true },
      
        {
          text: "报告智能解读",
          url: "LntelligentEvaluation",
          list: "LntelligentEvaluation",
          show: true,
        },
      ],
    };
  },
  computed: {
    id() {
      return this.$route.query.id || "";
    },
    user_no() {
      return this.$route.query.user_no || "";
    },
    showNav() {
      return this.$route.query.showNav || 0;
    },
  },
  methods: {
    showDialog() {
      this.showSigns = true;
    },
    oylstatus(status) {
      let level;
      switch (status) {
        case 1:
          level = 5;
          break;
        case 2:
          level = 4;
          break;
        case 3:
          level = 3;
          break;
        case 4:
          level = 2;
          break;
        case 5:
          level = 1;
          break;
      }
      return level;
    },
    /** 对象转数组 */
    objToArray(obj) {
      let arr = [];
      for (const key in obj) {
        arr.push({ title: key, ...obj[key] });
      }
      return arr;
    },
  },
  created() {
    let params = {
      user_no: this.user_no,
      test_report_id: this.id,
    };
    Report.getReports({ ...params }, (res, err) => {
      this.loading = true;
      if (!err) {
        res.healthy.forEach((e) => {
          e.btntxt = "查看建议";
          e.showCon = false;
        });
        res.special[0].descArr = res.special[0].desc.split("\\r\\n");
        res.special[1].descArr = res.special[1].desc.split("\\r\\n");
        res.diabetes.descArr = res.diabetes.diabetes_desc.split("\\r\\n");
        res.brain.descArr = res.brain.brain_desc.split("\\r\\n");

        res.special[4].status = this.oylstatus(res.special[4].status);
        for (let key in res.physiology_system) {
          res.physiology_system[key].forEach((e) => {
            e.showDetail = false;
            e.remakrs = e.remakrs ? e.remakrs.split("\\r\\n") : [];
          });
        }
        this.navData.forEach((item) => {
          // ✅ 正确写法：switch 判断 item.text
          switch (item.text) {
            case "健康概况":
              item.data = res;
              break;
            case "健康总评":
              item.data = res.special;
              break;
            case "生理系统风险":
              item.data = {
                ...res.physiology,
                physiology_system: res.physiology_system,
              };
              break;
            case "脑血管风险":
              item.data = res.brain;
              break;
            case "糖尿病风险":
              item.data = res.diabetes;
              break;
            case "疾病风险":
              item.data = res.disease;
              break;
            case "健康管理建议":
              item.data = {
                healthy: res.healthy,
                marks: res.marks,
              };
              break;
            case "报告智能解读":
              item.data = res.ai_report_data;
              break;

            default:
              break;
          }
        });
        if (res.is_ai_systemic_health == 0) {
          // 方案：倒序遍历删除，索引不会乱
          for (let i = this.navData.length - 1; i >= 0; i--) {
            const item = this.navData[i];
            if (item.text == "疾病风险") {
              this.navData.splice(i, 1);
            } else if (item.text == "健康管理建议") {
              this.navData.splice(i, 1);
            } else if (item.text == "脑血管风险") {
              
              this.navData.splice(i, 1); // 打开删除
            } else if (item.text == "糖尿病风险") {
              this.navData.splice(i, 1); // 打开删除
            }
          }
        }
        console.log(this.navData)
        this.loading = false;
      } else {
        console.log(err);
        Notify({ type: "warning", message: err.message });
      }
    });
  },
};
</script>
<style lang="scss" >
.layout {
  height: 100%;
}

.van-tabs--line .van-tabs__wrap {
  height: 80px !important;
  line-height: 80px;
  margin-bottom: 20px;
  width: 100%;
  font-size: 30px;
}

.van-tab__text {
  font-size: 30px;
}

.van-tabs__wrap--scrollable .van-tab {
  //    flex: 0 0 27% !important;
  font-size: 30px;
}

.vantabs {
  font-size: 30px;
  //    height: calc(100% - 100px);
  padding-bottom: 100px;
}

</style>